import React from 'react'
import { motion } from 'framer-motion'
import style from "./HeaderLogo.module.css"
import { Link } from 'react-router-dom'

const HeaderLogo = ({logo, scrolled}) => {
  return (
    <motion.div 
      className={`${style.Logo}`}
      animate={{
        filter: scrolled ? 'brightness(0.9)' : 'brightness(1)',
      }}
      transition={{ duration: 0.3 }}
    >
      <Link to="/">
        <motion.img 
          className={`${style.LogoImg}`} 
          src={logo} 
          alt="Talent14 Logo"
          animate={{
            scale: scrolled ? 0.95 : 1,
          }}
          transition={{ duration: 0.3 }}
        />
      </Link>
    </motion.div>
  )
}

export default HeaderLogo
